"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.calloutColors = exports.removeCalloutTitle = exports.calloutTitles = exports.calloutTypes = exports.calloutTypeIcons = void 0;
var types_1 = require("./types");
exports.calloutTypeIcons = (_a = {},
    _a[types_1.CalloutType.success] = "check-circle",
    _a[types_1.CalloutType.info] = "important-circle",
    _a[types_1.CalloutType.warning] = "important",
    _a[types_1.CalloutType.error] = "close-circle",
    _a[types_1.CalloutType.note] = "card-large",
    _a[types_1.CalloutType.decision] = "decision",
    _a);
/**
 * A list of all callout types
 */
exports.calloutTypes = [
    types_1.CalloutType.info,
    types_1.CalloutType.note,
    types_1.CalloutType.success,
    types_1.CalloutType.warning,
    types_1.CalloutType.error,
    types_1.CalloutType.decision,
];
exports.calloutTitles = (_b = {},
    // TODO: localize
    _b[types_1.CalloutType.success] = "Success",
    _b[types_1.CalloutType.info] = "Info",
    _b[types_1.CalloutType.warning] = "Warning",
    _b[types_1.CalloutType.error] = "Error",
    _b[types_1.CalloutType.note] = "Note",
    _b[types_1.CalloutType.decision] = "Decision",
    _b);
// TODO: localize
exports.removeCalloutTitle = "Delete";
exports.calloutColors = (_c = {},
    _c[types_1.CalloutType.success] = "green",
    _c[types_1.CalloutType.info] = "blue",
    _c[types_1.CalloutType.warning] = "yellow",
    _c[types_1.CalloutType.error] = "red",
    _c[types_1.CalloutType.note] = "purple",
    _c[types_1.CalloutType.decision] = "grey",
    _c);
